// src/lib/share.js
// Single source of truth for every outbound share link. ALL share surfaces
// (ShareSheet + any future "copy link" button) MUST import APP_URL / buildShareUrl
// from here — never hardcode the domain anywhere else.

export const APP_URL = "https://glowgrow.app";

/**
 * Build the public, deep-linkable URL for a share payload.
 * Falls back to the Landing page when the type is unknown.
 *
 * @param {{ type?: string, payload?: object } | null} share
 * @returns {string} absolute URL on https://glowgrow.app
 */
export function buildShareUrl(share) {
  if (!share || !share.type) return APP_URL + "/";
  const p = share.payload || {};
  switch (share.type) {
    case "article":
      return p.id ? `${APP_URL}/app/library?article=${encodeURIComponent(p.id)}` : `${APP_URL}/app/library`;
    case "recipe":
      return p.id ? `${APP_URL}/app/diy?recipe=${encodeURIComponent(p.id)}` : `${APP_URL}/app/diy`;
    case "challenge":
      return p.slug
        ? `${APP_URL}/app/challenges?challenge=${encodeURIComponent(p.slug)}`
        : `${APP_URL}/app/challenges`;
    case "dupe":
      return p.productName
        ? `${APP_URL}/app/dupes?q=${encodeURIComponent(p.productName)}`
        : `${APP_URL}/app/dupes`;
    case "report":
      return `${APP_URL}/app/insights`;
    default:
      return `${APP_URL}/`;
  }
}
